import { GET_LOCATION_DETAILS, CLEAR_LOCATION_DETAILS } from "../../constants";

const initialState = {
    data: null

}
export const GetLocationDetailsReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_LOCATION_DETAILS:

            return {
                ...state,
                data: action.payload
            };

        case CLEAR_LOCATION_DETAILS:
            return {
                ...state,
                data: null
            }
        default:
            return state
    }
}  